<mojo-navbar></mojo-navbar>
<div>
    <h2>
      Invalid Platform
      <br/>
      Please logout and log back in to access {{ getDbIdentityFromUrl() }}
    </h2>
</div>
